<template>
  <v-dialog
      :value="confirmModal.popup"
      max-width="400"
      persistent
  >
    <div class="custom-card" style="position: relative">
<!--      <v-btn absolute style="top: 4px; right: 4px" icon @click="closeModal">-->
<!--        <v-icon>close</v-icon>-->
<!--      </v-btn>-->
      <div class="flex-center">
        <div class="pa-6">
          <div class="flex-center mb-5">
            <Iconify
                :icon="returnIconType()"
                :color="returnIconColor()"
                size="75px"
            ></Iconify>
          </div>

          <div class="txt-head text-center theme-color-two mb-2">
            {{ confirmModal.title }}
          </div>

          <div class="text-center theme-color-two mb-10">
            {{ confirmModal.text }}
          </div>

          <div class="flex-center gap-24">
            <Button
                v-if="confirmModal.showCancel"
                theme="2"
                min-width="115px"
                height="50px"
                :label="confirmModal.cancelText"
                @onClick="closeModal"
            ></Button>
            <Button
                min-width="115px"
                height="50px"
                :theme="colorTheme.btnType"
                :label="confirmModal.buttonText"
                @onClick="eventClick"
            ></Button>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Button from "./input/Button"
import { mapState } from 'vuex'

export default {
  name: "ConfirmModal",
  components: {
    Button
  },
  computed: {
    ...mapState({
      confirmModal: state => state.General.confirmModal
    }),
    colorTheme () {
      switch (this.confirmModal.theme) {
        case 'warning':
          return { btnType: '6' }

        case 'success':
          return { btnType: '7' }

        default:
          return { btnType: '1' }
      }
    }
  },
  methods: {
    closeModal () {
      this.$store.commit('General/clearModal')
    },
    eventClick () {
      if ('action' in this.confirmModal) {
        this.confirmModal.action()
        this.$store.commit('General/clearModal')
      }
    },
    returnIconType () {
      switch (this.confirmModal.theme) {
        case 'save-draft':
          return 'ion:cube'

        case 'save':
          return 'mdi:book-open-blank-variant'

        case 'sign-out':
          return 'simple-line-icons:logout'

        case 'delete':
          return 'fa6-solid:trash-can'

        case 'send':
          return 'mdi:court-hammer'

        case 'extend':
          return 'ic:round-access-time-filled'

        case 'warning':
          return 'mingcute:warning-fill'

        case 'success':
          return 'ep:success-filled'
      }
    },
    returnIconColor () {
      switch (this.confirmModal.theme) {
        case 'warning':
          return 'var(--theme-color-nine)'

        case 'success':
          return '#C1F198'

        default:
          return 'var(--theme-color-five)'
      }
    }
  }
}
</script>

<style scoped>
.custom-line {
  width: 30px;
  height: 3px;
  border-radius: 2px;
}
</style>